/**
 * CLS 優化器 - 減少累積佈局偏移
 * 此腳本幫助減少頁面加載過程中的佈局偏移問題
 * 版本: 1.2 - 優化圖片加載效果
 */

// 優化 LazySizes 配置
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.loadMode = 2; // 使用更溫和的加載模式
window.lazySizesConfig.expFactor = 1.5; // 恢復到默認值
window.lazySizesConfig.preloadAfterLoad = true; 
window.lazySizesConfig.throttleDelay = 125;

// CLS Optimizer - 改進版
document.addEventListener('DOMContentLoaded', function() {
  // 溫和處理圖片容器
  handleImageContainers();
  
  // 預加載關鍵字體
  preloadCriticalFonts();
  
  // 處理可能導致佈局偏移的元素
  handleLayoutShiftElements();
  
  // 增強懶加載圖片效果
  enhanceLazyLoadedImages();
});

// 增強懶加載圖片效果 - 新增
function enhanceLazyLoadedImages() {
  // 處理已經加載的圖片
  var loadedImages = document.querySelectorAll('img.lazyloaded');
  loadedImages.forEach(function(img) {
    var placeholder = getImagePlaceholder(img);
    if (placeholder) {
      fadeOutElement(placeholder);
    }
  });
  
  // 監聽將來懶加載的圖片
  document.addEventListener('lazyloaded', function(e) {
    var img = e.target;
    if (img.tagName === 'IMG') {
      var placeholder = getImagePlaceholder(img);
      if (placeholder) {
        fadeOutElement(placeholder);
      }
    }
  });
}

// 獲取圖片對應的佔位符元素
function getImagePlaceholder(img) {
  // 查找常見的佔位符類名模式
  var container = img.closest('.product-card__image-wrapper, .product-single__photo-wrapper, .img-container');
  if (!container) return null;
  
  // 嘗試不同的佔位符選擇器
  var placeholder = container.querySelector('.placeholder-svg, .placeholder-background, .placeholder, .product-card__image-placeholder, [class*="placeholder"]');
  return placeholder;
}

// 淡出元素
function fadeOutElement(element) {
  if (!element || element.classList.contains('hidden') || element.style.display === 'none') return;
  
  // 添加過渡效果
  element.style.transition = 'opacity 0.3s ease-out';
  element.style.opacity = '0';
  
  // 300毫秒後隱藏元素
  setTimeout(function() {
    element.style.display = 'none';
    element.classList.add('hidden');
  }, 300);
}

// 溫和處理圖片容器，只處理未設置尺寸的容器
function handleImageContainers() {
  // 獲取特定類型的圖片容器
  var specificContainers = [
    '.product-card__image-wrapper', 
    '.product-single__photo-wrapper',
    '.img-container',
    '.grid-view-item__image-wrapper'
  ];
  
  var containers = document.querySelectorAll(specificContainers.join(','));
  
  containers.forEach(function(container) {
    // 檢查容器是否已經有樣式處理
    if (container.hasAttribute('data-cls-fixed')) {
      return;
    }
    
    // 獲取容器內的圖片
    var img = container.querySelector('img');
    if (!img) {
      return;
    }
    
    // 檢查容器是否已有明確的高度
    var computedStyle = getComputedStyle(container);
    if (computedStyle.height !== 'auto' && computedStyle.height !== '0px') {
      return;
    }
    
    // 獲取圖片尺寸信息
    var width = img.getAttribute('width') || img.dataset.width;
    var height = img.getAttribute('height') || img.dataset.height;
    
    // 只在有尺寸信息時設置容器比例
    if (width && height) {
      var ratio = (height / width * 100);
      // 只在比例合理的情況下應用
      if (ratio > 0 && ratio < 200) {
        container.style.position = 'relative';
        container.style.paddingBottom = ratio + '%';
        container.style.height = '0';
        container.style.overflow = 'hidden';
        
        // 將圖片設置為絕對定位，填充容器
        if (img.style.position !== 'absolute') {
          img.style.position = 'absolute';
          img.style.top = '0';
          img.style.left = '0';
          img.style.width = '100%';
          img.style.height = '100%';
          img.style.objectFit = 'contain';
        }
      }
    }
    
    // 標記容器已處理
    container.setAttribute('data-cls-fixed', 'true');
  });
}

// 預加載關鍵字體
function preloadCriticalFonts() {
  var criticalFonts = [
    '/assets/font1.woff2',
    '/assets/font2.woff2'
  ];
  
  criticalFonts.forEach(function(fontUrl) {
    var link = document.createElement('link');
    link.rel = 'preload';
    link.href = fontUrl;
    link.as = 'font';
    link.type = 'font/woff2';
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
}

// 處理可能導致佈局偏移的元素
function handleLayoutShiftElements() {
  // 信任徽章部分
  var trustBadges = document.querySelectorAll('.trust-badges');
  trustBadges.forEach(function(badge) {
    if (badge.offsetHeight) {
      badge.style.minHeight = badge.offsetHeight + 'px';
    }
  });
  
  // 商品描述部分
  var productDescriptions = document.querySelectorAll('.product-single__description');
  productDescriptions.forEach(function(desc) {
    if (desc.offsetHeight > 20) {
      desc.style.minHeight = desc.offsetHeight + 'px';
    }
  });
  
  // 修復 Slick Carousel 的佈局偏移
  var slickSliders = document.querySelectorAll('.slick-slider');
  slickSliders.forEach(function(slider) {
    if (!slider.hasAttribute('data-cls-fixed')) {
      // 等待 Slick 初始化完成
      if (typeof slider.slick === 'function') {
        slider.addEventListener('afterChange', function() {
          // 重新計算高度並固定
          if (slider.offsetHeight) {
            slider.style.minHeight = slider.offsetHeight + 'px';
          }
        });
      }
      slider.setAttribute('data-cls-fixed', 'true');
    }
  });
  
  // 修復導航菜單的佈局偏移
  var navItems = document.querySelectorAll('.site-nav__item');
  navItems.forEach(function(item) {
    var dropdown = item.querySelector('.site-nav__dropdown');
    if (dropdown) {
      // 確保下拉菜單不會導致佈局偏移
      dropdown.style.minHeight = 'fit-content';
      dropdown.style.opacity = '0';
      dropdown.style.transition = 'opacity 0.2s ease-in-out';
      
      item.addEventListener('mouseenter', function() {
        dropdown.style.opacity = '1';
      });
      
      item.addEventListener('mouseleave', function() {
        dropdown.style.opacity = '0';
      });
    }
  });
}

// 溫和的圖片處理方式
document.addEventListener('lazybeforeunveil', function(e) {
  var img = e.target;
  
  // 僅處理未設置尺寸的圖片
  if (img.tagName === 'IMG' && !img.hasAttribute('data-cls-fixed')) {
    var container = img.parentNode;
    
    // 檢查容器是否屬於特定類別，避免過度干預
    var isProductImage = container && (
      container.classList.contains('product-card__image-wrapper') || 
      container.classList.contains('product-single__photo-wrapper') ||
      container.classList.contains('img-container')
    );
    
    var isSlideshow = container && (
      container.classList.contains('slideshow__image-wrapper') || 
      container.classList.contains('banner-image-wrapper')
    );
    
    // 只有特定容器類型才應用預設尺寸
    if (isProductImage || isSlideshow) {
      // 获取已计算样式，避免重复设置
      var computedStyle = getComputedStyle(container);
      
      // 只有在需要時才設置容器樣式
      if (computedStyle.position === 'static') {
        container.style.position = 'relative';
      }
      
      if (computedStyle.overflow === 'visible') {
        container.style.overflow = 'hidden';
      }
      
      // 檢查是否已設置寬高比並且是否需要設置
      if (!container.style.paddingBottom && !container.getAttribute('data-ratio-set')) {
        // 檢查圖片是否有尺寸信息
        var width = img.getAttribute('width') || img.dataset.width;
        var height = img.getAttribute('height') || img.dataset.height;
        
        // 如果有寬高信息，設置正確的寬高比
        if (width && height) {
          var ratio = (height / width * 100) + '%';
          container.style.paddingBottom = ratio;
          if (!container.style.height) {
            container.style.height = '0';
          }
        } 
        // 根據特定容器類型應用默認比例
        else if (isProductImage) {
          // 檢查容器是否已有高度設置
          if (computedStyle.height === 'auto' || computedStyle.height === '0px') {
            container.style.paddingBottom = '100%';
            container.style.height = '0';
          }
        } 
        else if (isSlideshow) {
          // 檢查容器是否已有高度設置
          if (computedStyle.height === 'auto' || computedStyle.height === '0px') {
            container.style.paddingBottom = '56.25%';
            container.style.height = '0';
          }
        }
        
        container.setAttribute('data-ratio-set', 'true');
      }
      
      // 標記已處理過的圖片
      img.setAttribute('data-cls-fixed', 'true');
    }
  }
});

// 優化圖片容器，使用更溫和的方式
function setupImageContainers() {
  // 僅選擇特定類型的圖片容器
  var specificContainers = document.querySelectorAll(
    '.product-card__image-wrapper, .product-single__photo-wrapper, ' +
    '.slideshow__image-wrapper, .banner-image-wrapper, ' +
    '.img-container'
  );
  
  // 保守地為容器設置樣式
  specificContainers.forEach(function(container) {
    if (!container.getAttribute('data-cls-fixed')) {
      var computedStyle = getComputedStyle(container);
      
      // 檢查現有樣式，避免覆蓋有意義的樣式
      if (computedStyle.position === 'static') {
        container.style.position = 'relative';
      }
      
      if (computedStyle.overflow === 'visible') {
        container.style.overflow = 'hidden';
      }
      
      // 根據容器類型選擇性地設置高寬比
      if (
        (container.classList.contains('product-card__image-wrapper') || 
         container.classList.contains('product-single__photo-wrapper') ||
         container.classList.contains('img-container')) &&
         !container.style.paddingBottom &&
         (computedStyle.height === 'auto' || computedStyle.height === '0px')
      ) {
        container.style.paddingBottom = '100%';
        container.style.height = '0';
      } 
      else if (
        (container.classList.contains('slideshow__image-wrapper') || 
         container.classList.contains('banner-image-wrapper')) &&
         !container.style.paddingBottom &&
         (computedStyle.height === 'auto' || computedStyle.height === '0px')
      ) {
        container.style.paddingBottom = '56.25%';
        container.style.height = '0';
      }
      
      // 標記已處理過的容器
      container.setAttribute('data-cls-fixed', 'true');
    }
  });
  
  // 更謹慎地處理圖片
  var productImages = document.querySelectorAll(
    '.product-card__image, .product-single__photo, .slideshow__image, ' +
    '.banner-image, .img-container img'
  );
  
  productImages.forEach(function(img) {
    if (!img.getAttribute('data-cls-fixed')) {
      var container = img.parentNode;
      var computedStyle = getComputedStyle(container);
      
      // 僅當父容器具有正確的定位時才應用絕對定位
      if (computedStyle.position !== 'static' && 
          computedStyle.position !== '' && 
          container.hasAttribute('data-cls-fixed')) {
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
        
        // 標記已處理過的圖片
        img.setAttribute('data-cls-fixed', 'true');
      }
    }
  });
}

// 處理字體加載，使用更安全的方法
function handleFontLoading() {
  // 檢查 FontFaceObserver 是否可用
  if (typeof FontFaceObserver !== 'undefined') {
    try {
      // 標記字體正在加載
      document.documentElement.classList.add('fonts-loading');
      
      // 監控字體加載完成
      var fontObservers = [
        new FontFaceObserver('Font Awesome 5 Brands'),
        new FontFaceObserver('Font Awesome 5 Free', { weight: 400 }),
        new FontFaceObserver('Font Awesome 5 Free', { weight: 900 })
      ];
      
      // 當所有字體加載完成時，更新類名
      Promise.all(fontObservers.map(function(observer) {
        return observer.load(null, 3000); // 設置更短的超時
      })).then(function() {
        document.documentElement.classList.remove('fonts-loading');
        document.documentElement.classList.add('fonts-loaded');
      }).catch(function() {
        // 如果加載失敗，也移除加載類名
        document.documentElement.classList.remove('fonts-loading');
      });
    } catch(e) {
      console.log('Font loading optimization failed:', e);
      // 移除可能導致問題的類
      document.documentElement.classList.remove('fonts-loading');
    }
  }
}

// 修復 Mega Menu 位置問題，僅針對特定元素
function fixMegaMenu() {
  var megaMenus = document.querySelectorAll('.mega-menu__content');
  megaMenus.forEach(function(menu) {
    // 僅當 top 設置為非 auto 時修改
    if (getComputedStyle(menu).top !== 'auto') {
      menu.style.top = 'auto';
    }
  });
}

// 監聽窗口加載完成事件，謹慎地進行最終修復
window.addEventListener('load', function() {
  // 修復特定問題的輪播圖
  var slickSliders = document.querySelectorAll('.slick-slider');
  slickSliders.forEach(function(slider) {
    if (!slider.getAttribute('data-cls-fixed')) {
      var slickList = slider.querySelector('.slick-list');
      if (slickList && !slickList.style.height && getComputedStyle(slickList).height === '0px') {
        slickList.style.height = 'auto';
      }
      slider.setAttribute('data-cls-fixed', 'true');
    }
  });
  
  // 移除潛在的可能導致問題的 will-change 屬性
  setTimeout(function() {
    document.querySelectorAll('[style*="will-change"]').forEach(function(el) {
      // 只移除我們設置的 will-change
      if (el.style.willChange === 'transform, opacity' && el.hasAttribute('data-cls-fixed')) {
        el.style.willChange = '';
      }
    });
  }, 3000); // 給足夠的時間完成動畫
}); 